<template>
  <div class="a-transition-fade m-card-primary m-login">
    <AtomLogoPrimary/>
    <form
      autocomplete="off"
      class="a-form-column"
      name="login-form"
      @submit.prevent="createUsuarioLogin"
    >
      <p
        v-if="loginError"
        class="font-weight-bold text-color-danger text-align-center"
      >
        {{ $t('mLogin.alerts.handleAuthentication.error') }}
      </p>
      <AtomInputPrimary
        v-model="login.email"
        :inputError="$v.login.email.$error"
        :messageError="messageErrorEmail"
        name="usuario"
        :placeholder="$t('mLogin.inputs.usuario.placeholder')"
        reference="usuario"
        type="email"
        @blur="$v.login.email.$touch()"
      />
      <AtomInputPrimary
        v-model="login.password"
        :inputError="$v.login.password.$error"
        :messageError="messageErrorPassword"
        name="contraseña"
        :placeholder="$t('mLogin.inputs.contraseña.placeholder')"
        reference="contraseña"
        type="password"
        @blur="$v.login.password.$touch()"
      />
      <AtomButtonPrimary :button-primary="buttonPrimary"/>
      <a
        class="text-color-vidroop-primary"
        href="#"
        @click.prevent="gotToForgetPassword"
      >
        {{ $t('mLogin.forgetPassword') }}
      </a>
    </form>
  </div>
</template>

<script>
import { email, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeLogin',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mLogin.buttonPrimary'),
        behavior: 'login',
        class: 'a-button-login text-transform-uppercase width-100-pr',
        sending: false,
        type: 'submit'
      },

      login: {
        email: '',
        password: ''
      },

      loginError: false
    }
  },

  validations: {
    login: {
      email: {
        email,
        required
      },

      password: {
        required
      }
    }
  },

  computed: {
    messageErrorEmail () {
      return this.$validation.getValidationMessage('mLogin', this.$v.login.email, 'email')
    },

    messageErrorPassword () {
      return this.$validation.getValidationMessage('mLogin', this.$v.login.password, 'password')
    }
  },

  methods: {
    gotToForgetPassword () {
      this.$router.push(`/${this.$t('rPaths.forgetPassword')}`)
    },
    createUsuarioLogin () {
      this.$v.$touch()
      this.$nextTick(() => this.$validation.focusInputError(this))
      if (!this.buttonPrimary.sending && !this.$v.$invalid) {
        this.buttonPrimary.sending = true
        this.$services.create('usuario', 'createUsuarioLogin', this.login)
          .then(response => {
            let cognito = response.data
            console.log(cognito)
            if (!cognito.error) {
              this.$auth.handleAuthentication(cognito)
              this.loginError = false
            } else {
              this.loginError = true
              this.buttonPrimary.sending = false
            }
          })
          .catch(error => {
            console.log(error)
            this.buttonPrimary.sending = false
            this.loginError = true
          })
      }
    }
  }
}
</script>
